module.exports = __webpack_public_path__ + "img/gettyimages-746114359-1024-x-1024-ok-large@2x.e9e5fd76.png";